export const replaceSpaceWith_ = (toReplace: string): string => {
	if (!toReplace) {
		return "";
	}
	return toReplace.split(" ").join("_");
};

export const capitalizeString = (toCapitalize: string): string => {
	const words = toCapitalize.split(" ");
	return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};

export function ellipsis(str: string, maxLength: number): string {
	const ellipsisStr = "...";
	if (str.length <= maxLength) {
		return str;
	}
	return str.slice(0, maxLength - ellipsisStr.length) + ellipsisStr;
}

/** `"1 filter"` / `"3 filters"`. Pass `plural` for a word the trailing "s" does not cover. */
export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
	return `${count} ${count === 1 ? singular : plural}`;
}
